import React, { useState, useEffect } from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { BandFormTypes } from "../OutputMappingAgeForm/Types";
import { OutputConfigBandMap } from "../../Api/Types";
import { Input, Checkbox } from "../../../../Common/UI/Index";
import { InputType } from "../../../../Common/UI/Types";

interface Props {
  /**
   * Data from api response
   */
  data: BandFormTypes[];
  /**
   * Initial form data for selectables
   */
  SelectableData?: OutputConfigBandMap[];
  /**
   * Config name
   */
  configName: string;
  /**
   * Antion on valid data is available
   */
  onPayloadDataAvailable: (data: OutputConfigBandMap[]) => void;

}

/**
 * Responsible for rendering output banding mapping form
 */
export const OutputBandingMappingFormView: React.FC<Props> = (props: Props) => {
  const { data, SelectableData, onPayloadDataAvailable } = props;
  const { t: translate } = useTranslation();
  const [payloadData, setPayloadData] = useState<OutputConfigBandMap[]>([]);

  /**
   * Handle when checkbox or tag value changes
   */
  /* Const onValueChange = (
    e: React.SyntheticEvent<any, Event>,
    index: number): void => {
    const target = e.currentTarget;
    const tempData = [...payloadData];
    if (tempData[index]) {
      if (target.type === "checkbox") {
        tempData[index][target.name] = target.checked;
      }
      else {
        tempData[index][target.name] = target.value;
      }
    }
    setPayloadData([...tempData]);
  }; */

  const onTagChange = (
    e: React.SyntheticEvent<any, Event>,
    index: number
  ): void => {
    const target = e.currentTarget;
    const tempData = [...payloadData];
    if (tempData[index]) {
      tempData[index][target.name] = target.value;
    }
    setPayloadData([...tempData]);
  };

  /**
   * On change event to select all Include XML
   * @param isSelected - true if Select all for Include XML is checked
   */
  const onIncludeCheckXMLSelecAllChange = (
    isSelected: boolean
  ): void => {
    const tempData = [...payloadData];
    tempData.forEach((item) => {
      item.includeInOutput = isSelected;
    });
    setPayloadData([...tempData]);
  };

  /**
   * On change event to select all Include XML
   * @param isSelected - true if Select all for Include XML is checked
   */
  const onBandNameSelecAllChange = (
    isSelected: boolean
  ): void => {
    const tempData = [...payloadData];
    tempData.forEach((item) => {
      item.isBandName = isSelected;
    });
    setPayloadData([...tempData]);
  };

  const onIncludeCheckXML = (
    isSelected: boolean,
    name: string,
    index: number
  ): void => {
    const tempData = [...payloadData];
    tempData[index][name] = isSelected;
    setPayloadData([...tempData]);
  };

  useEffect(() => {
    if (SelectableData && SelectableData.length > 0) {
      setPayloadData([...SelectableData]);
    }
    else {
      setPayloadData([]);
    }
  }, [data]);

  useEffect(() => {
    const availablePayloadData = payloadData.filter((item: OutputConfigBandMap) =>
      item.includeInOutput && item.tag && item.isBandName);
    onPayloadDataAvailable(availablePayloadData);
  }, [payloadData]);


  return (
    <div className="output-config__band_check_form">
      <div className="output-config__band_check_form-titleContainer">
        <div className="output-config__band_check_form__title-grid">
          <Checkbox
            id="ebt-outputConfig-config-bandSelect"
            labelText="Band Name"
            name="bandName"
            onChange={onBandNameSelecAllChange}
          />
          <span>Mapping Tag</span>
          <Checkbox
            id="ebt-outputConfig-config-mapping-includeXml"
            labelText="Include Xml"
            name="includeXml"
            onChange={onIncludeCheckXMLSelecAllChange}
          />
        </div>
      </div>
      {
        payloadData && payloadData.map((item: OutputConfigBandMap, index: number) => {
          return (
            <div className="output-config__band_check_form__grid" key={index}>
              <Checkbox
                id={`ebt-outputConfig-config-mapping-${index}`}
                labelText={item.name}
                name="bandName"
                checked={item.isBandName}
                onChange={(isSelected: boolean): void => onIncludeCheckXML(isSelected, "isBandName", index)}
              />
              <Input
                id={`ebt-outputConfig-config-mapping-tag-${index}`}
                type={InputType.Text}
                name="tag"
                placeholder="Tag"
                onChange={(e: React.SyntheticEvent<any, Event>): void => onTagChange(e, index)}
              />
              <Checkbox
                className="ebt-mapping__include-in-xml"
                id={`ebt-outputConfig-config-mapping-includeOutput-${index}`}
                labelText={translate("OutputConfig.OutputMappingAgeForm.IncludeInOutput")}
                name="includeInOutput"
                checked={item.includeInOutput}
                onChange={(isSelected: boolean): void => onIncludeCheckXML(isSelected, "includeInOutput", index)}
              />
            </div>
          );
        })
      }
    </div>
  );
};
